import React from 'react';
import PropTypes from 'prop-types';

const PromoName = ({lineItemPromoName}) => (
    <React.Fragment>
        <p><b>{lineItemPromoName}</b></p>
    </React.Fragment>
);

PromoName.propTypes = {
    lineItemPromoName: PropTypes.string.isRequired
};

export default PromoName
